import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { AbstractTuiControl } from '@taiga-ui/legacy';

import { InputItemType, InputSize } from '../../types';
import { SearchCitiesService } from '../../services';
import { DEFAULT_CITY } from '../../city-switcher';

@Component({
  selector: 'app-search-cities-button',
  templateUrl: './search-cities-button.component.html',
  styleUrls: ['./search-cities-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchCitiesButtonComponent extends AbstractTuiControl<InputItemType> {
  private readonly searchCitiesService = inject(SearchCitiesService);

  @Input() size: InputSize = 'm';
  @Input() loading = false;

  protected searchQuery = '';
  protected open = false;

  readonly topCities$ = this.searchCitiesService.topCities$;
  readonly searchCities$ = this.searchCitiesService.searchCities$;

  private readonly destroyed$$ = new Subject<void>();

  get focused(): boolean {
    return false;
  }

  get selectedCityLabel() {
    return this.value?.city ? this.value.city : DEFAULT_CITY.city;
  }

  protected getFallbackValue(): InputItemType {
    return DEFAULT_CITY;
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.searchCitiesService.loadTopCities();
    this.searchCitiesService.resetSearchCities();
  }

  ngOnDestroy(): void {
    this.searchCitiesService.resetSearchCities();

    this.destroyed$$.next();
    this.destroyed$$.complete();
  }

  setValue(city: InputItemType) {
    this.value = city;
    this.open = false;
  }

  onSearchChange(text: string) {
    this.searchCitiesService.searchCities(text);
  }
}
